/* eslint-disable */
import { OverlayPanel as Panel } from "primereact/overlaypanel";

export const OverlayPanel = Panel;